import { faRotateRight } from "@fortawesome/pro-solid-svg-icons";
import { useImagePreviewHandlers } from "../../image-preview-context";
import { Tool } from "./tool";
import { ToolboxToolProps } from "./toolbox.types";

/**
 * Rotate tool for the ImagePreview toolbox. Rotates the image by 90 degrees.
 */
export const Rotate = (props: ToolboxToolProps) => {
    const handlers = useImagePreviewHandlers();
    return <Tool icon={faRotateRight} label="Rotate" onClick={handlers.rotate} {...props} />;
};
